import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useMatch } from 'react-router-dom';
import IdolSelector from '@/components/ui/IdolSelector';

/**
 * 數據分析容器頁
 *
 * 收入／粉絲兩個子頁共用同一個偶像選擇器，切換子頁時不需重選；
 * selectedIdol 透過 Outlet context 傳給子頁。
 */
function AnalyticsLayout() {
  const { t } = useTranslation();
  const isFanPage = useMatch('/settings/analytics/fan');

  const [selectedIdol, setSelectedIdol] = useState('');

  const titleKey = isFanPage ? 'analytics_fan' : 'analytics_income';

  return (
    <div>
      <h3 className="mb-4">{t(titleKey)}</h3>

      {/* 偶像選擇器 */}
      <IdolSelector
        value={selectedIdol}
        onChange={setSelectedIdol}
        className="mb-4"
      />

      <Outlet context={{ selectedIdol }} />
    </div>
  );
}

export default AnalyticsLayout;
